import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7d236984&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {RadioButton: require('/home/runner/work/myody_front/myody_front/components/radio/RadioButton.vue').default,RadioGroup: require('/home/runner/work/myody_front/myody_front/components/radio/RadioGroup.vue').default,DatePicker: require('/home/runner/work/myody_front/myody_front/components/date/DatePicker.vue').default,GoodsHistoryList: require('/home/runner/work/myody_front/myody_front/components/goods/GoodsHistoryList.vue').default,Card: require('/home/runner/work/myody_front/myody_front/components/card/Card.vue').default})
